import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: '1',
    border: '0.0625rem solid #F1F1F1',
    borderRadius: '1rem',
    boxSizing: 'border-box',
    boxShadow: '0 4px 6px 0 rgba(66,81,89,0.05)',
    backgroundColor: 'white'
  }
}))

export default useStyles
